// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3443":"ace3ed2c","5282":"2734cbce","6398":"a9dccb82","8740":"438d30b1"}[chunkId] + ".chunk.css";
};